import React, { createContext, useState, useContext, useEffect } from 'react';

// Create Context
const PaginationContextBezPrzekazania = createContext();

// Custom Hook to use the Pagination Context
export const usePaginationBezPrzekazania = () => {
  return useContext(PaginationContextBezPrzekazania);
};

// PaginationProvider Component
export const PaginationProviderBezPrzekazania = ({ children }) => {
  const [pagination, setPagination] = useState({
    current: JSON.parse(localStorage.getItem('currentPageMSRBezPrzekazania')) || 1,
    pagesize: JSON.parse(localStorage.getItem('PageSizeBezPrzekazania')) || 20,
    loading: false,
    specialfilter: JSON.parse(localStorage.getItem('specialfilterBezPrzekazania')) || null,
    search: JSON.parse(localStorage.getItem('searchBezPrzekazania')) || '',
    advancedSearch: JSON.parse(localStorage.getItem('advancedSearchMSRBezPrzekazania')) || null,
    orderby: [],
  });

  // Update localStorage whenever pagination state changes
  useEffect(() => {
    localStorage.setItem('currentPageMSRBezPrzekazania', JSON.stringify(pagination.current));
    localStorage.setItem('specialfilterBezPrzekazania', JSON.stringify(pagination.specialfilter));
    localStorage.setItem('PageSizeBezPrzekazania', JSON.stringify(pagination.pagesize));
    localStorage.setItem('searchBezPrzekazania', JSON.stringify(pagination.search));
    localStorage.setItem('advancedSearchMSRBezPrzekazania', JSON.stringify(pagination.advancedSearch));
  }, [pagination]);

  return (
    <PaginationContextBezPrzekazania.Provider value={{ pagination, setPagination }}>
      {children}
    </PaginationContextBezPrzekazania.Provider>
  );
};
